import moment from 'moment-timezone'
import type { TDateRange } from '../types'

export const buildDateGrid = (dateRange: TDateRange, timezone: string): string[] => {
  const dates: string[] = []
  const cursor = moment.tz(dateRange.dateFrom, timezone).startOf('day')
  const end = moment.tz(dateRange.dateTo, timezone).startOf('day')

  while (cursor.isSameOrBefore(end, 'day')) {
    dates.push(cursor.format('YYYY-MM-DD'))

    cursor.add(1, 'day')
  }

  return dates
}
